import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Response } from '@app/core/model';
import { Observable, filter, map } from 'rxjs';

import { SubtitlesFileValidationDataDTO, SubtitlesFileValidationDataModel } from '../../models';
import { isHttpResponse } from '@app/shared/utils';

interface ValidationResponse<Data> {
    body: Response<Data>;
}

@Injectable()
export class SubtitlesUploaderHttpsService {
    constructor(private httpClient: HttpClient) {}

    validateSubtitlesFile(formData: FormData, url: string): Observable<SubtitlesFileValidationDataModel> {
        const req = new HttpRequest('POST', url, formData, {
            headers: new HttpHeaders({
                'Content-Type': 'multipart/form-data',
            }),
        });

        return this.httpClient.request(req).pipe(
            filter((event) => isHttpResponse(event)),
            map((event) => event as unknown as ValidationResponse<SubtitlesFileValidationDataDTO>),
            map((res) => new SubtitlesFileValidationDataModel(res.body.data)),
        );
    }
}
